module.exports = __webpack_public_path__ + "img/lwi-ugiagbe-green.1a1ca454.jpg";